
import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from "react-router-dom"
import { Button, Typography, Avatar, Paper } from "@material-ui/core"
import Typing from 'react-typing-animation';
import { useDispatch } from "react-redux"
import useStyles from "./styles"
import Lang from "../../Lang"
import Notify from './Notify'
import { checkGoogleSessionToken } from '../../api';

const Navbar = () => {

    const classes = useStyles()
    const userFromStorage = JSON.parse(localStorage.getItem("profile"))
    const [user, setUser] = useState(userFromStorage)
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const logout = () => {
        dispatch({ type: "LOGOUT" })
        history.push("/auth")
        setUser(null)
    }

    // Log out en 1h
    const checkUserSession = async (token) => {
        try {
            await checkGoogleSessionToken(token)
            setUser(userFromStorage)
        } catch (error) {
            logout()
        }
    }

    useEffect(() => {
        if (userFromStorage) {
            checkUserSession(userFromStorage?.token)
        }
        if (user && !userFromStorage) {
            setUser(null)
        }
    }, [location])

    const handleLang = (e) => {
        localStorage.setItem("lang", e.target.value)
        history.push("/")
        window.location.reload()
    }

    return (
        <div className={classes.appBar} position="static" color="inherit">
            <Notify />
            <Paper className={classes.toolbar} elevation={6}>
                <Button className={classes.home} component={Link} to="/" align="center">
                    <Typing>
                        <Typing.Speed ms={1} />
                        <Typing.Backspace count={15} />
                        <h1 className={classes.title} component={Link} to="/">MecaNews</h1>
                    </Typing>
                </Button>

                {user ? (
                    <Button className={classes.profile} component={Link} to="/preferences">
                        <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                        <Typography className={classes.userName} variant="h6">{user.result.name}</Typography>
                    </Button>
                ) : (
                    <div className={classes.profile}>
                        <Button component={Link} to="/auth" variant="contained" color="primary" className={classes.logIn}><Lang props={"Inicia sesión"} /></Button>
                        <select onChange={handleLang} className={classes.lang_select}>
                            <option value="es" selected={localStorage.getItem("lang") === "es"}>Español</option>
                            <option value="en" selected={localStorage.getItem("lang") === "en"}>English</option>
                        </select>
                    </div>

                )}
            </Paper>
        </div>
    )
}

export default Navbar
